import { render, staticRenderFns } from "./adulticide.vue?vue&type=template&id=16468600&"
import script from "./adulticide.vue?vue&type=script&lang=js&"
export * from "./adulticide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports